(function () {
  'use strict';

  function setSearchOpen(searchWrap, searchBtn, open) {
    if (!searchWrap || !searchBtn) return;

    var input = searchWrap.querySelector('input');
    var iconOpen = searchBtn.querySelector('[data-dictac-search-icon="open"]');
    var iconClose = searchBtn.querySelector(
      '[data-dictac-search-icon="close"]'
    );

    searchWrap.classList.toggle('dictac-header__search--open', open);
    searchBtn.setAttribute('aria-label', open ? 'Close search' : 'Open search');

    if (iconOpen) iconOpen.hidden = open;
    if (iconClose) iconClose.hidden = !open;

    if (input) {
      input.tabIndex = open ? 0 : -1;
      input.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) input.focus();
    }
  }

  function closeNavDropdowns(nav) {
    if (!nav) return;
    nav.querySelectorAll('details[open]').forEach(function (details) {
      details.removeAttribute('open');
      var summary = details.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
  }

  function initNavDropdowns(nav) {
    if (!nav) return;

    nav
      .querySelectorAll(
        '.dictac-header__dropdown > details, .dictac-header__submenu-nested'
      )
      .forEach(function (details) {
        details.addEventListener('toggle', function () {
          var summary = details.querySelector(':scope > summary');
          if (summary) {
            summary.setAttribute(
              'aria-expanded',
              details.open ? 'true' : 'false'
            );
          }

          if (!details.open || !details.closest('.dictac-header__dropdown'))
            return;

          nav
            .querySelectorAll('.dictac-header__dropdown > details[open]')
            .forEach(function (other) {
              if (other === details) return;
              other.removeAttribute('open');
              var otherSummary = other.querySelector(':scope > summary');
              if (otherSummary)
                otherSummary.setAttribute('aria-expanded', 'false');
            });
        });
      });
  }

  function initHeader(wrap) {
    if (!wrap || wrap.dataset.dictacHeaderInit) return;
    wrap.dataset.dictacHeaderInit = 'true';

    var header = wrap.querySelector('[data-dictac-header]');
    var nav = wrap.querySelector('[data-dictac-nav]');
    var menuBtn = wrap.querySelector('[data-dictac-menu-btn]');
    var overlay = wrap.querySelector('[data-dictac-menu-overlay]');
    var searchWrap = wrap.querySelector('[data-dictac-search]');
    var searchBtn = wrap.querySelector('[data-dictac-search-btn]');
    var isOverlay =
      header && header.classList.contains('dictac-header--overlay');
    var enableSticky = !header || header.dataset.stickyHeader !== 'false';
    var unlockScroll = null;

    if (isOverlay && header && enableSticky) {
      var onScroll = function () {
        header.classList.toggle('dictac-header--scrolled', window.scrollY > 80);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    function closeMenu() {
      if (!nav) return;
      nav.classList.remove('dictac-header__nav--open');
      if (overlay) overlay.hidden = true;
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
      closeNavDropdowns(nav);
      if (unlockScroll) {
        unlockScroll();
        unlockScroll = null;
      }
    }

    function closeSearch() {
      if (!searchWrap || !searchBtn) return;
      setSearchOpen(searchWrap, searchBtn, false);
    }

    if (menuBtn && nav) {
      menuBtn.addEventListener('click', function () {
        var open = nav.classList.toggle('dictac-header__nav--open');
        if (overlay) overlay.hidden = !open;
        menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          closeSearch();
          unlockScroll = window.DictacHome.lockBodyScroll(true);
        } else {
          closeMenu();
        }
      });
    }

    initNavDropdowns(nav);

    document.addEventListener('click', function (e) {
      if (!nav || window.matchMedia('(max-width: 1100px)').matches) return;
      if (e.target.closest('[data-dictac-nav] .dictac-header__dropdown'))
        return;
      closeNavDropdowns(nav);
    });

    if (overlay) {
      overlay.addEventListener('click', closeMenu);
    }

    if (nav) {
      nav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', closeMenu);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    if (searchBtn && searchWrap) {
      searchBtn.addEventListener('click', function () {
        var open = !searchWrap.classList.contains(
          'dictac-header__search--open'
        );
        if (open) closeMenu();
        setSearchOpen(searchWrap, searchBtn, open);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-dictac-header-wrap]').forEach(initHeader);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var wrap =
      e.target.querySelector('[data-dictac-header-wrap]') ||
      (e.target.matches('[data-dictac-header-wrap]') ? e.target : null);
    if (wrap) initHeader(wrap);
  });
})();
